const formatters = {
    date(val) {
        return _.isNull(val) ? '' : moment(val).format('D.M.Y')
    },
    datetime(val) {
        return _.isNull(val) ? '' : moment(val).format('D.M.Y HH:mm')
    },
    datetimeexact(val) {
        return _.isNull(val) ? '' : moment(val).format('D.M.Y HH:mm:ss')
    },
    color_code_select(val, store) {
        if (_.isObject(val)) {
            const out = `<span class="color-badge-old" style="background: ${val.color_code};"></span>&nbsp;${val.label}`;
            return store.ng.injector.get('$sce').trustAsHtml(out);
        } else {
            return '';
        }
    },
    image(val, store) {
        if (_.isObject(val)) {
            return `<div class="table-thumbnail"><img class="grid-image" src="${val.thumbnail}" alt="${val.name}" title="${val.name}"/>${val.name}</div>`;
        } else {
            return '';
        }
    },
    file(val, store) {
        if (_.isObject(val)) {
            return val.name;
        } else {
            return '';
        }
    },
    array_of_strings(val, store) {
        return val.join(', ');
    }
};

export default {
    getCell(row, col, store, stripHtml) {
        if (!col) {
            return '';
        }
        let out = '';
        const sanitize = store.ng.injector.get('$sanitize');

        if (col.template && _.isFunction(col.template)) {
            out = col.template(row, col, store);
        } else if (formatters[col.type]) {
            out = formatters[col.type](_.get(row, col.key), store);
        } else if (col.type === 'string' && col.filter_information && col.filter_information.type === 'enum') {
            const value = _.get(col.filter_information, 'data.' + _.get(row, col.key), '');
            if (value !== '') {
                out = value;
            } else {
                out = _.get(row, col.key);
            }
        } else if(col.type === 'json') {
            if(_.startsWith(col.key, 'bo_day_range_')) {
                out = '';
                const value = _.get(row, col.key, null);
                if(value) {
                    out += '<ul>';
                    _.each(value, (boRow) => {
                        out += `<li>${boRow.label}: ${moment(boRow.meta.start_date).format('D.M.Y')} - ${moment(boRow.meta.end_date).format('D.M.Y')}
</li>`;
                    });
                    out += '</ul>';
                }
            }
        } else {
            if(col.is_multiline) {
                let tmpString = _.get(row, col.key);
                tmpString = tmpString.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br/>$2')
                out = tmpString
            } else {
                out = _.get(row, col.key);
            }
        }

        if (_.isString(out)) {
            if (stripHtml) {
                out = String(out).replace(/<[^>]+>/gm, '');
            }

            out = out.trim();
        }

        return out;
    },
    isEqual(expected, actual) {
        return _.isEqual(expected, actual)
    }
}



// WEBPACK FOOTER //
// ./src/app/store/base/helpers.js